import React from 'react'
import { TouchableOpacity } from 'react-native'

import { Flex } from '../../../components/FlexBox'
import TrashIcon from '../../../components/icon/TrashIcon'
import useTranslation from '../../../hooks/useTranslation'
import { IContentFeedBoost } from '../queries/getContentFeeds'
import ContentItemSummary from './ContentItemSummary'
import OpenInMi6Link from './OpenInMi6Link'
import { TableCol, TableRow } from './Table'

interface BoostRowProps {
  boost: IContentFeedBoost
  onRemove: () => void
}

export const BoostRow = ({ boost, onRemove }: BoostRowProps) => {
  const { t } = useTranslation()

  return (
    <TableRow>
      <TableCol style={{ minWidth: 240 }}>
        <ContentItemSummary item={boost.item} />
      </TableCol>
      <TableCol style={{ maxWidth: 88, minWidth: 88 }}>
        <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
          <OpenInMi6Link boost={boost} />
          <TouchableOpacity
            onPress={onRemove}
            accessibilityLabel={t('contentCuration:detail:removeItem')}
            style={{ marginLeft: 8 }}
          >
            <TrashIcon size={20} />
          </TouchableOpacity>
        </Flex>
      </TableCol>
    </TableRow>
  )
}

export default BoostRow
